<template>
    <i :class="button.icon" class="pointer" @click="sendRequest" data-toggle="tooltip" :title="button.buttonText"></i>
</template>

<script>
export default {
    name: 'SaveParticipantProfileToggleButton',

    props: {
        endpoint: {
            type: String,
            required: true,
        },

        isSavedProfile: {
            required: true,
        },

        isLargeIcon: {
            type: Boolean,
        },
    },

    data() {
        return {
            internalIsSavedProfile: this.isSavedProfile,
        }
    },

    computed: {
        button() {
            const largeIcon = this.isLargeIcon ? 'fa-lg' : '';
            if (this.internalIsSavedProfile) {
                return {
                    icon: `fas fa-check-circle fa-lg ${largeIcon} text-success`,
                    buttonText: 'Remove this information from quicker bookings',
                }
            }

            return {
                icon: `far fa-check-circle fa-lg ${largeIcon} text-mute`,
                buttonText: 'Save this information for quicker bookings in the future',
            }
        },
    },

    methods: {
        sendRequest() {
            this.internalIsSavedProfile = !this.internalIsSavedProfile

            axios.post(this.endpoint).catch(error => {
                //If error then revert the icon
                this.internalIsSavedProfile = !this.internalIsSavedProfile
                alert(error.response.data.message);
            });
        },
    },
}
</script>

<style lang="scss" scoped>

.text-mute {
    color: #ddd;
}
</style>



// WEBPACK FOOTER //
// src/Assets/components/Participants/SaveParticipantProfileToggleButton.vue